import React, { FC } from 'react'
import moment from 'moment-timezone'
import { get } from 'lodash'
import { Text, Icon } from '@saasalerts/ui'
import { Event } from '@/components/Graphs/types'
import { CHART_COLORS } from '@/utils/chartMethods'
import { momentUTC } from '@/utils/momentUTC'
import { faXmark } from '@awesome.me/kit-e270131d0a/icons/classic/regular'
export const SEVERITY_COLOR = {
  low: CHART_COLORS.green,
  medium: CHART_COLORS.amber,
  critical: CHART_COLORS.red,
} as const

const ListItem = ({
  title,
  value,
  component,
}: {
  title: string
  value?: string
  component?: React.ReactElement
}) => {
  return (
    <li className="flex flex-col space-x-0 sm:flex-row sm:space-x-2">
      <Text className="flex flex-col font-normal">
        <span className="font-bold">{title}</span>
        {component ? (
          component
        ) : (
          <span className="flex flex-col space-y-2">{value}</span>
        )}
      </Text>
    </li>
  )
}

export const EventInfo: FC<{
  onCloseClick: () => void
  event: Event
}> = ({ onCloseClick, event }) => {
  const dateAndTime = event.date
    ? momentUTC(event.date)
        .tz(moment.tz.guess())
        .format('MM/DD/YYYY HH:mm:ss z')
    : ''

  const colorObj = {
    critical: 'red',
    medium: 'orange',
    low: 'green',
  }

  const color = get(colorObj, event.alertStatus)
  return (
    <div
      className="relative max-w-xs rounded border-2 bg-white p-2 dark:bg-dark-surface"
      style={{
        borderColor: color,
      }}
    >
      <>
        <Icon
          icon={faXmark}
          onClick={() => onCloseClick()}
          className="absolute right-2 top-2 size-6 cursor-pointer text-gray-100 dark:text-gray-900"
        />
        <ul className="space-y-0.5 leading-loose">
          <ListItem title="Date / Time" value={dateAndTime} />
          <ListItem
            title="Account Detail"
            component={
              <>
                <span className="flex flex-col leading-tight">
                  <div>Name: {event?.name}</div>
                  <div>Email: {event?.account}</div>
                  <div>Organization: {event?.organization}</div>
                </span>
              </>
            }
          />

          <ListItem
            title="IP"
            component={
              <span className="flex flex-col leading-relaxed">
                <div>{event?.ip}</div>
                <div>{event?.location?.country}</div>
              </span>
            }
          />

          <ListItem
            title="Application"
            component={
              <>
                <span className="flex flex-col leading-tight">
                  <div>{event?.product}</div>
                  <div
                    style={{
                      color:
                        SEVERITY_COLOR[
                          event.alertStatus as keyof typeof SEVERITY_COLOR
                        ],
                    }}
                  >
                    {event?.incident}
                  </div>
                </span>
              </>
            }
          />
        </ul>
      </>
    </div>
  )
}
